module.exports = function getResource(label, vars = []) {
    let resources = {
        toViewYourProfilePlease: 'To view your profile, please',
        signIn: 'sign in',
        notifications: 'Notifications',
        messages: 'Messages'
    };
    return resources[label];
};
